import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompanyUsageReportData,
  getEmployeeSpecficData,
  selectCompanyDashboard,
} from "../../../redux/slices/companyDashboardSlice";
import { getInitials } from "../../../shared/lib/getInitials";
import { getRandomHex } from "../../../shared/lib/getRandomHex";
import {useFormattedAmount} from "../../../hooks/useFormattedAmount";


function UserRequestsTableBody({ tableData }) {
  const navigate = useNavigate();
  const location = useLocation();

  const formatFunction = useFormattedAmount();
  // const goToEmployeeReport = async (id, serviceid) => {
  //   navigate(
  //     `/company_dashboard/services/usage_report/${serviceid}?dataId=${id}`,
  //     {
  //       state: { id: id, serviceid: serviceid, page: "company_dashboard" },
  //       replace: false,
  //     }
  //   );
  // };

  const goToEmployeeReport = (id, serviceid) => {
    const isPersonalDashboard = location.pathname.includes("personal_dashboard");

    const basePath = isPersonalDashboard
      ? "/personal_dashboard/teams/employee/usage_report"
      : "/company_dashboard/services/usage_report";

    navigate(`${basePath}/${serviceid}?dataId=${id}`, {
      state: {
        id: id,
        serviceid: serviceid,
        page: isPersonalDashboard ? "personal_dashboard" : "company_dashboard",
      },
      replace: false,
    });
  };

  return (
    <tbody>
      {tableData.map((row, index) => (
        <tr
          key={index}
          className="hover:bg-[#363D50] hover:brightness-125 cursor-pointer rounded-[24px]"
          onClick={() => {
            goToEmployeeReport(row?.user?.user_id, row?.user?.service_id);
          }}
        >
          {Object.keys(row).map((item, index2) => {
            const [hexColor, hexWithOpacity] = getRandomHex();
            return (
              <td
                key={index2}
                className="text-secondary !text-left !text-[#FFFFFF] py-[24px] px-[16px]"
              >
                {item === "user" && (
                  <div className="flex flex-start items-center gap-[10px]">                    
                    <div
                      style={{
                        backgroundColor: hexWithOpacity,
                        color: hexColor,
                      }}
                      className="w-[40px] h-[40px] rounded-full flex items-center justify-center !font-semibold"
                    >
                      {getInitials(row[item]["name"])}
                    </div>
                    <div className="flex flex-col">
                      <span className="text-secondary !text-left !text-[#FFFFFF]">
                        {row[item]["name"]}
                      </span>
                      <span className="text-secondary !text-left">
                        {row[item]["work"]}
                      </span>
                    </div>
                  </div>
                )}
                {item === "rating" && (
                  <div>
                    {row[item] === 3 && (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.1667 3.5C7.3802 3.5 3.5 7.3802 3.5 12.1667C3.5 16.9531 7.3802 20.8333 12.1667 20.8333C16.9531 20.8333 20.8333 16.9531 20.8333 12.1667C20.8333 7.3802 16.9531 3.5 12.1667 3.5ZM2.5 12.1667C2.5 6.82791 6.82791 2.5 12.1667 2.5C17.5054 2.5 21.8333 6.82791 21.8333 12.1667C21.8333 17.5054 17.5054 21.8333 12.1667 21.8333C6.82791 21.8333 2.5 17.5054 2.5 12.1667ZM8.5 8.87085C8.77614 8.87085 9 9.09471 9 9.37085V9.46252C9 9.73866 8.77614 9.96252 8.5 9.96252C8.22386 9.96252 8 9.73866 8 9.46252V9.37085C8 9.09471 8.22386 8.87085 8.5 8.87085ZM15.8333 8.87085C16.1095 8.87085 16.3333 9.09471 16.3333 9.37085V9.46252C16.3333 9.73866 16.1095 9.96252 15.8333 9.96252C15.5572 9.96252 15.3333 9.73866 15.3333 9.46252V9.37085C15.3333 9.09471 15.5572 8.87085 15.8333 8.87085ZM8.97434 13.8419C8.88702 13.5799 8.60386 13.4383 8.34189 13.5257C8.07991 13.613 7.93833 13.8961 8.02566 14.1581C8.53003 15.6712 9.86333 17.25 12.1667 17.25C14.47 17.25 15.8033 15.6712 16.3077 14.1581C16.395 13.8961 16.2534 13.613 15.9914 13.5257C15.7295 13.4383 15.4463 13.5799 15.359 13.8419C14.9467 15.0788 13.915 16.25 12.1667 16.25C10.4183 16.25 9.38664 15.0788 8.97434 13.8419Z"
                          fill="#6BE261"
                        />
                      </svg>
                    )}

                    {row[item] === 2 && (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.5 12.1667C3.5 7.3802 7.3802 3.5 12.1667 3.5C16.9531 3.5 20.8333 7.3802 20.8333 12.1667C20.8333 16.9531 16.9531 20.8333 12.1667 20.8333C7.3802 20.8333 3.5 16.9531 3.5 12.1667ZM12.1667 2.5C6.82791 2.5 2.5 6.82791 2.5 12.1667C2.5 17.5054 6.82791 21.8333 12.1667 21.8333C17.5054 21.8333 21.8333 17.5054 21.8333 12.1667C21.8333 6.82791 17.5054 2.5 12.1667 2.5ZM9 9.37085C9 9.09471 8.77614 8.87085 8.5 8.87085C8.22386 8.87085 8 9.09471 8 9.37085V9.46252C8 9.73866 8.22386 9.96252 8.5 9.96252C8.77614 9.96252 9 9.73866 9 9.46252V9.37085ZM16.3333 9.37085C16.3333 9.09471 16.1095 8.87085 15.8333 8.87085C15.5572 8.87085 15.3333 9.09471 15.3333 9.37085V9.46252C15.3333 9.73866 15.5572 9.96252 15.8333 9.96252C16.1095 9.96252 16.3333 9.73866 16.3333 9.46252V9.37085ZM8.5 13.5C8.22386 13.5 8 13.7239 8 14C8 14.2762 8.22386 14.5 8.5 14.5H15.8333C16.1095 14.5 16.3333 14.2762 16.3333 14C16.3333 13.7239 16.1095 13.5 15.8333 13.5H8.5Z"
                          fill="#FFE766"
                        />
                      </svg>
                    )}

                    {row[item] === 1 && (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.1667 3.5C7.3802 3.5 3.5 7.3802 3.5 12.1667C3.5 16.9531 7.3802 20.8333 12.1667 20.8333C16.9531 20.8333 20.8333 16.9531 20.8333 12.1667C20.8333 7.3802 16.9531 3.5 12.1667 3.5ZM2.5 12.1667C2.5 6.82791 6.82791 2.5 12.1667 2.5C17.5054 2.5 21.8333 6.82791 21.8333 12.1667C21.8333 17.5054 17.5054 21.8333 12.1667 21.8333C6.82791 21.8333 2.5 17.5054 2.5 12.1667ZM8.5 8.87085C8.77614 8.87085 9 9.09471 9 9.37085V9.46252C9 9.73866 8.77614 9.96252 8.5 9.96252C8.22386 9.96252 8 9.73866 8 9.46252V9.37085C8 9.09471 8.22386 8.87085 8.5 8.87085ZM15.8333 8.87085C16.1095 8.87085 16.3333 9.09471 16.3333 9.37085V9.46252C16.3333 9.73866 16.1095 9.96252 15.8333 9.96252C15.5572 9.96252 15.3333 9.73866 15.3333 9.46252V9.37085C15.3333 9.09471 15.5572 8.87085 15.8333 8.87085ZM12.1667 12.5834C9.86333 12.5834 8.53003 14.1622 8.02566 15.6753C7.93833 15.9372 8.07991 16.2204 8.34189 16.3077C8.60386 16.395 8.88702 16.2535 8.97434 15.9915C9.38664 14.7546 10.4183 13.5834 12.1667 13.5834C13.915 13.5834 14.9467 14.7546 15.359 15.9915C15.4463 16.2535 15.7295 16.395 15.9914 16.3077C16.2534 16.2204 16.395 15.9372 16.3077 15.6753C15.8033 14.1622 14.47 12.5834 12.1667 12.5834Z"
                          fill="#ED4650"
                        />
                      </svg>
                    )}
                  </div>
                )}

                {item === "monthly_cost" && <span>{formatFunction(row[item])}</span>}

                {item !== "user" &&
                  item !== "rating" &&
                  item !== "monthly_cost" &&
                  row[item]}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
}

export default UserRequestsTableBody;
